// Product model is intentionally a discriminated union keyed by
// `category`. Adding a new sellable thing later (e.g. "gifts",
// "themes") means adding one more member to this union and one
// more card component — nothing else in the type system needs
// to change.

export type ProductCategory = 'stars' | 'premium';

export type ProductBadge = 'best-value' | 'featured' | 'popular';

export type ProductTag = 'featured' | 'popular';

export interface BaseProduct {
  id: string;
  category: ProductCategory;
  title: string;
  subtitle?: string;
  price: number;
  currency: string;
  badge?: ProductBadge;
  tags?: ProductTag[];
}

export interface StarProduct extends BaseProduct {
  category: 'stars';
  amount: number;
}

export interface PremiumProduct extends BaseProduct {
  category: 'premium';
  durationMonths: number;
  perMonthPrice: number;
}

export type Product = StarProduct | PremiumProduct;

export function isStarProduct(product: Product): product is StarProduct {
  return product.category === 'stars';
}

export function isPremiumProduct(product: Product): product is PremiumProduct {
  return product.category === 'premium';
}
